__turbopack_context__.v({
  "content": "onboarding-module-scss-module__z-ksQa__content",
  "footer": "onboarding-module-scss-module__z-ksQa__footer",
});
